import { LoginEmailActions } from './actions';

const initialState = {
  user: null,
  loading: false,
  error: '',
  requiresNewPassword: false,
  challengeUser: null,
};

export function loginWithEmailReducer(state, action) {
  switch (action.type) {
    case LoginEmailActions.LOGIN_EMAIL:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case LoginEmailActions.LOGIN_EMAIL_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        requiresNewPassword: false,
        challengeUser: null,
      };
    case LoginEmailActions.LOGIN_EMAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LoginEmailActions.LOGIN_EMAIL_NEW_PASSWORD_REQUIRED:
      return {
        ...state,
        loading: false,
        requiresNewPassword: true,
        challengeUser: action.payload,
        error: '',
      };
    case LoginEmailActions.LOGIN_EMAIL_COMPLETE_NEW_PASSWORD:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case LoginEmailActions.LOGIN_EMAIL_RESET:
    default:
      return initialState;
  }
}
